import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AlertPortal } from 'AppSrc/core/components/portals/alert-portal';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  updateEditCrqWithId,
  revokeApproversFromViewCrq,
} from 'AppSrc/core/actions/actions-update-edit-form';
import { flAddApproverGroupsToCrq } from 'AppSrc/core/crq/crq-list-actions';
import { fetchCrqForViewEdit } from 'AppSrc/core/actions/actions-edit-form';
import { ES_VIEWING_NEW_SECTION } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import 'AppSrc/core/components/forms/select-coordinator/view-crq-select-individual-approver.css';
import 'AppSrc/core/style/components/view-crq-screen/change-assignee-modal.css';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-actions.css';
import { CRQ_STATUS_TRANSITIONS } from '../../crq/crq-status-transitions';

const RevokeApprovalGrantedUnconnected = React.memo(({
  groupId,
  group,
  revokeApproverCall,
  network,
  crqId,
  fullName,
  email,
  userId,
  revokeUserId,
}) => {

  const [openDialog, setOpenDialog] = useState(false);
  const [revokeReason, setRevokeReason] = useState('');
  const [enableSubmit, setEnableSubmit] = useState(false);

  const openRevokeModal = () => {
    setOpenDialog(true);
  };

  const onClickYes = () => {
    const groupIdArray = {
      id: groupId,
      name: group,
    };
    const individualIdArray = {
      network,
      id: userId,
      crqId,
      full_name: fullName,
      email,
    };

    if (group !== '-') {
      revokeApproverCall(groupIdArray, individualIdArray, revokeReason);
    }
    setOpenDialog(!openDialog);
  };

  const onClickNo = () => {
    setOpenDialog(!openDialog);
  };

  const handleRevokeReason = (e) => {
    setRevokeReason(e.target.value);
    if (revokeReason.length > 19) {
      setEnableSubmit(true);
    }
  };


  return (
    <React.Fragment>
      <div className="assign-to-me-container">
        <button
          className="assign-to-me"
          type="button"
          title="Cancel Approval"
          onClick={openRevokeModal}
        >
          Revoke
        </button>
      </div>
      {openDialog && (
      <AlertPortal>
        <div className="alert-section">
          <div className="alert-shadow" />
          <div className="alert-inner">
            <div className="alert-texts">
              <h1 className="alert-heading">
                Are you sure you want to Revoke the approval granted to this CRQ?
              </h1>
              <h5 className="alert-message">Please provide a detailed reason for revoking this approval(min. 20 characters)</h5>
              <textarea
                className="revoke-textarea"
                type="textarea"
                placeholder="Please enter text"
                maxLength={200}
                value={revokeReason}
                onChange={handleRevokeReason}
              />
              <div className="characters-limit">
                Character Limit
                {' '}
                {revokeReason.length}
                /200
              </div>
              <h3 className="popup-heading">Please be reminded that post revoking, we highly recommend to refresh the page again to see the changes made in Approvals!</h3>
            </div>
            <div className="alert-options alert-options-spacemaker" />
            <div className="alert-options">
              <div className="form-nav-section">
                <div className="side-left">
                  <OptionButton
                    className="false-button"
                    type="button"
                    onClick={onClickNo}
                  >
                    No
                  </OptionButton>
                </div>
                <div className="side-right">
                  <button
                    className={`action-button submit-btn
                    ${((revokeReason ? revokeReason.length > 19 : 0) && enableSubmit) ? 'btn-active' : 'btn-inActive'}`}
                    type="submit"
                    onClick={onClickYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AlertPortal>
      )}
    </React.Fragment>
  );
});

RevokeApprovalGrantedUnconnected.propTypes = {
  groupId: PropTypes.string,
  group: PropTypes.string,
  network: PropTypes.string,
  crqId: PropTypes.string,
  revokeApproverCall: PropTypes.func,
  fullName: PropTypes.string,
  email: PropTypes.string,
  userId: PropTypes.string,
  revokeUserId: PropTypes.string,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  revokeApproverCall(groupIdArray, individualIdArray, revokeReason) {
    const {
      network,
      crqId,
      // email,
      groupId,
      revokeUserId,
    } = ownProps;
    window.sessionStorage.setItem('revokeNote', `${revokeUserId} ${groupId} ${revokeReason}`);
    const statusTransition = CRQ_STATUS_TRANSITIONS.revokeApproval;

    dispatch(updateEditCrqWithId(crqId, statusTransition))
      // .then(() => {
      //   dispatch(updateEditCrqWithId(crqId, statusTransition));
      // })
      .then(() => {
        dispatch(revokeApproversFromViewCrq(network, crqId, groupIdArray, individualIdArray))
          .then(() => {
            dispatch(flAddApproverGroupsToCrq(network, crqId))
              .then(() => {
                dispatch(fetchCrqForViewEdit({
                  editingStatus: ES_VIEWING_NEW_SECTION,
                  crqId,
                  network,
                }));
              });
          });
      })
      .catch((error) => {
        console.error(error);
        // TODO add error alert
      });
  },
});

const RevokeApprovalGranted = connect(
  null,
  mapDispatchToProps,
)(RevokeApprovalGrantedUnconnected);

export {
  RevokeApprovalGranted,
};
